module.exports = __webpack_public_path__ + "static/img/negx_2.802dfdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/3dapps/skybox/tidepool/negx_2.jpg
// module id = uBaY
// module chunks = 2